/**
 * Buscador AJAX para produtos
 * 
 * @package MF_Concessionarias_2025
 */

(function($) {
    'use strict';
    
    let searchTimeout;
    const searchDelay = 500; // 500ms de delay para evitar muchas peticiones
    
    $(document).ready(function() {
        // Elementos
        const searchToggle = $('#search-toggle');
        const searchBar = $('#search-bar');
        const mainMenu = $('#main-menu');
        const searchClose = $('#search-close');
        const searchInput = $('#ajax-search-input');
        const searchLoader = $('#search-loader');
        const searchResults = $('#search-results');
        const searchResultsContainer = $('#search-results-container');
        const searchNoResults = $('#search-no-results');
        const searchViewAll = $('#search-view-all');
        const searchTerm = $('#search-term');
        
        // Abrir barra de búsqueda
        searchToggle.on('click', function(e) {
            e.preventDefault();
            mainMenu.addClass('hidden');
            searchBar.removeClass('hidden');
            hideResultsContainer();
            searchInput.focus();
        });
        
        // Cerrar barra de búsqueda
        searchClose.on('click', function(e) {
            e.preventDefault();
            closeSearchBar();
        });
        
        // Cerrar con ESC
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && !searchBar.hasClass('hidden')) {
                closeSearchBar();
            }
        });
        

        
        // Búsqueda en tiempo real
        searchInput.on('input', function() {
            const query = $(this).val().trim();
            
            // Limpiar timeout anterior
            clearTimeout(searchTimeout);
            
            if (query.length === 0) {
                hideResultsContainer();
                return;
            }
            
            if (query.length < 2) {
                return; // Esperar al menos 2 caracteres
            }
            
            // Mostrar loader después del delay
            searchTimeout = setTimeout(function() {
                performSearch(query);
            }, searchDelay);
        });
        
        // Función para cerrar la barra de búsqueda
        function closeSearchBar() {
            searchBar.addClass('hidden');
            mainMenu.removeClass('hidden');
            searchInput.val('');
            hideResultsContainer();
        }
        
        // Ocultar contenedor de resultados
        function hideResultsContainer() {
            searchResultsContainer.addClass('hidden');
            hideAllStates();
        }
        
        // Mostrar estado sin resultados
        function showNoResultsState() {
            searchResultsContainer.removeClass('hidden');
            hideAllStates();
            searchNoResults.removeClass('hidden');
        }
        
        // Mostrar resultados
        function showResultsState() {
            searchResultsContainer.removeClass('hidden');
            hideAllStates();
            searchResults.removeClass('hidden');
        }
        
        // Mostrar loader
        function showLoaderState() {
            searchResultsContainer.removeClass('hidden');
            hideAllStates();
            searchLoader.removeClass('hidden');
        }
        
        // Ocultar todos los estados
        function hideAllStates() {
            searchLoader.addClass('hidden');
            searchResults.addClass('hidden');
            searchNoResults.addClass('hidden');
        }
        
        // Realizar búsqueda AJAX
        function performSearch(query) {
            showLoaderState();
            
            // Verificar si ajaxSearch está definido
            if (typeof ajaxSearch === 'undefined') {
                console.error('ajaxSearch no está definido. Verificar wp_localize_script.');
                showNoResultsState();
                return;
            }
            
            $.ajax({
                url: ajaxSearch.ajaxurl,
                type: 'POST',
                data: {
                    action: 'mf_ajax_search',
                    nonce: ajaxSearch.nonce,
                    query: query
                },
                success: function(response) {
                    if (response.success && response.data) {
                        if (response.data.results && response.data.results.length > 0) {
                            displayResults(response.data.results, query);
                            showResultsState();
                        } else {
                            showNoResultsState();
                        }
                    } else {
                        showNoResultsState();
                    }
                },
                error: function() {
                    showNoResultsState();
                }
            });
        }
        
        // Mostrar resultados en el DOM
        function displayResults(results, query) {
            const resultsContainer = searchResults.find('.space-y-3');
            resultsContainer.empty();
            
            results.forEach(function(item) {
                const resultHtml = `
                    <div class="search-result-item flex items-start space-x-4 p-3 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer" onclick="window.location.href='${item.url}'">
                        <div class="flex-shrink-0">
                            ${item.image ? 
                                `<img src="${item.image}" alt="${item.title}" class="w-16 h-16 object-cover rounded-lg">` :
                                `<div class="w-16 h-16 flex items-center justify-center">
                                    <i class="bi bi-image text-secondary"></i>
                                </div>`
                            }
                        </div>
                        <div class="flex-1 min-w-0">
                            <h4 class="text-base font-normal text-vermelho truncate">${item.title}</h4>
                            <p class="text-sm text-secondary mt-1">${item.type_label}</p>
                            ${item.excerpt ? `<p class="text-xs text-secondary mt-1 line-clamp-2">${item.excerpt}</p>` : ''}
                        </div>
                        <div class="flex-shrink-0">
                            <i class="bi bi-arrow-right text-secondary"></i>
                        </div>
                    </div>
                `;
                resultsContainer.append(resultHtml);
            });
            
            // Configurar enlace "Ver todos los resultados"
            searchTerm.text(query);
            const searchUrl = `${window.location.origin}/?s=${encodeURIComponent(query)}`;
            searchViewAll.find('a').attr('href', searchUrl);
            searchViewAll.removeClass('hidden');
        }
    });
    
})(jQuery);
